import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, AlertCircle } from "lucide-react";
import api from "@/lib/api";
import { Brand } from "@/components/Brand";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sid = params.get("session_id");
  const [state, setState] = useState("checking");

  useEffect(() => {
    if (!sid) { setState("error"); return; }
    let tries = 0; let active = true;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (!active) return;
        if (data.payment_status === "paid") { setState("paid"); return; }
        if (data.status === "expired" || data.payment_status === "failed") { setState("error"); return; }
      } catch (e) {}
      if (++tries >= 8) { setState("pending"); return; }
      setTimeout(poll, 2000);
    };
    poll();
    return () => { active = false; };
  }, [sid]);

  return (
    <div className="min-h-screen bg-[#F1F4F3] flex flex-col items-center justify-center px-6 text-center">
      <div className="mb-10"><Brand size={40} /></div>
      <div data-testid="payment-status" className="max-w-md">
        {state === "checking" && (
          <>
            <Loader2 size={40} className="text-brand animate-spin mx-auto mb-6" />
            <h1 className="font-display font-black text-3xl mb-3 text-[#0E1E2E]">Confirming your order…</h1>
            <p className="text-[#556673]">Hang tight while we confirm your payment.</p>
          </>
        )}
        {state === "paid" && (
          <>
            <CheckCircle2 size={48} className="text-brand mx-auto mb-6" />
            <h1 className="font-display font-black text-4xl mb-3 text-[#0E1E2E]">You're all set!</h1>
            <p className="text-[#556673] mb-8">Thanks for your purchase. Your ebook is on its way — check your email for the download.</p>
          </>
        )}
        {state === "pending" && (
          <>
            <Loader2 size={40} className="text-brand animate-spin mx-auto mb-6" />
            <h1 className="font-display font-black text-3xl mb-3 text-[#0E1E2E]">Payment processing</h1>
            <p className="text-[#556673] mb-8">This is taking a moment. You'll get a confirmation email shortly.</p>
          </>
        )}
        {state === "error" && (
          <>
            <AlertCircle size={48} className="text-[#D14B6B] mx-auto mb-6" />
            <h1 className="font-display font-black text-3xl mb-3 text-[#0E1E2E]">Something went wrong</h1>
            <p className="text-[#556673] mb-8">We couldn't confirm this payment. If you were charged, contact us and we'll sort it out.</p>
          </>
        )}
        <Link to="/" data-testid="back-home" className="inline-block px-8 py-4 bg-brand text-[#06111C] font-display font-bold uppercase tracking-wide text-sm hover:bg-[#27B95B] transition-colors">
          Back to UMG Media
        </Link>
      </div>
    </div>
  );
}
